export default [
    {
    path: '/register/phoneRegisterTwo',
    name: 'phoneRegisterTwo',
    meta: {
      index: 3
    },
    component: () => import('@/views/register/phoneRegisterTwo')
  }
  ]
  